import { Button } from "@/components/ui/button";
import ampaLogo from "@/assets/platform-logo.png";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSupabaseAuth } from "@/hooks/useSupabaseAuth";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export default function LandingNavigation({ onScheduleDemo }: { onScheduleDemo: () => void }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { user } = useSupabaseAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    const { error } = await supabase.auth.signOut();
    if (error) {
      toast.error("Failed to log out");
    } else {
      navigate("/");
    }
  };

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b bg-background/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-2 cursor-pointer"
          >
            <img src={ampaLogo} alt="AMPA Network" className="h-8 w-8" />
            <span className="text-2xl font-bold text-foreground">AMPA Network</span>
          </button>

          <div className="hidden md:flex items-center gap-3">
                <Button variant="ghost" onClick={() => navigate(user ? "/dashboard" : "/auth")}>
                  Login
                </Button>
                <Button
                  className="bg-[#3b82f6] hover:bg-[#3b82f6]/90"
                  onClick={onScheduleDemo}
                >
                  Schedule Demo
                </Button>
          </div>

          <button
            className="md:hidden"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t">
            <div className="flex flex-col gap-2">
              <Button variant="ghost" onClick={() => navigate(user ? "/dashboard" : "/auth")}>Login</Button>
              <Button className="bg-[#3b82f6] hover:bg-[#3b82f6]/90" onClick={onScheduleDemo}>
                Schedule Demo
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}
